import { createSlice } from '@reduxjs/toolkit';
import {
  // fetchDiets,
  fetchDietById,
  fetchDietByPatientId,
  deleteDietById,
  // updateDietById,
  createNewDiet,
} from '../actions/dietActions';

const dietSlice = createSlice({
  name: 'diets',
  initialState: {
    diets: [],
    currentDiet: null,
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentDiet: (state, action) => {
      state.currentDiet = action.payload;
    },
    clearCurrentDiet: (state) => {
      state.currentDiet = null;
    },
    clearDiets: (state) => {
      state.diets = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDietByPatientId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDietByPatientId.fulfilled, (state, action) => {
        state.loading = false;
        state.diets = action.payload.data || [];  // Garante que seja sempre um array
        // console.log('Diets fetched:', action.payload.data);
      })
      .addCase(fetchDietByPatientId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchDietById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDietById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentDiet = action.payload.data || null;
      })
      .addCase(fetchDietById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Criar nova dieta
      .addCase(createNewDiet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewDiet.fulfilled, (state, action) => {
        state.loading = false;
        state.diets.push(action.payload);
      })
      .addCase(createNewDiet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteDietById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDietById.fulfilled, (state, action) => {
        state.loading = false;
        state.diets = state.diets.filter(diet => diet.diet_id !== action.payload);
      })
      .addCase(deleteDietById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      ;
  },
});

export const { setCurrentDiet, clearCurrentDiet, clearDiets } = dietSlice.actions;
export default dietSlice.reducer;
